import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { APIHelperService } from './apiHelper.service';

@Injectable({ providedIn: 'root' })
export class RealPageService {

  constructor(
    private http: HttpClient,
    private apiHelper: APIHelperService
  ) {
    // no-op
  }

  getAllProspects() {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageProspects', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  checkRealPageWorkers(id) {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageWorkers', {id: id}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getSources() {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageSources', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getSourcesQuery() {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageSourcesQuery', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  startGetAdminDetails(pmcid, siteid) {
    return this.http.post<any>(this.apiHelper.fillUrl('realPageAdminDetailsStart', {}, {}), { pmcid, siteid })
      .pipe(map(data => {
        return data;
      }));
  }

  getAdminDetailsJob(jobId) {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageAdminDetails', {jobId}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getLeasingAgents() {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageAgents', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  verifyAndCreateRealPageIntegration(payload) {
    return this.http.post<any>(this.apiHelper.fillUrl('verifyIntegration', {type: 'realpage'}, {}), payload)
    .pipe(map(data => {
      return data;
    }));
  }
}
